import Logging from "../Logging.js";
import StateStoreBase from "./StateStoreBase.js";
class SharedTranslationStore extends StateStoreBase {
  constructor() {
    super(...arguments);
    this.translations = null;
  }
  get() {
    if (!this.translations && !window.isTesting) {
      void Logging.warning("Store has not been populated yet");
    }
    return this.translations ?? {
      cancel: () => "",
      cannotChange: () => "",
      dontShowAgain: () => "",
      endOfList: () => "",
      fieldRequired: () => "",
      genericError: () => "",
      invalidDate: () => "",
      loadMore: () => "",
      ok: () => ""
    };
  }
  populate(translations) {
    this.translations = translations;
    this.notifySubscribers();
  }
}
const sharedTranslationStore = new SharedTranslationStore();
export {
  sharedTranslationStore as default
};
//# sourceMappingURL=sharedTranslationStore.js.map
